import React from 'react';
import Layout from '../../components/Layout';
import HeadMessage from "../../components/Common/HeadMessage/HeadMessage";
import Support from "./Support";

async function action({ fetch }) {
    return {
        title: 'Support',
        chunks: ['support'],
        component: (
            <Layout>
                <HeadMessage>
                    <h1><span>Support</span></h1>
                </HeadMessage>

                <Support/>
            </Layout>
        ),
    };
}

export default action;
